<template>
  <footer class="bg-dark text-white pt-5 pb-4" data-n="footer1">
    <div class="container">
      <div class="row gy-4 pb-4 border-bottom border-secondary">

        <div class="col-md-4" data-n="footer-brand">
          <h5 class="fw-bold mb-2">
            <router-link class="text-white text-decoration-none d-inline-flex align-items-center gap-1" to="/">
              <span class="nav-flower" aria-hidden="true"></span>
              Berlin <span class="red mx-1">Connect-the-Dots</span> Tours
            </router-link>
          </h5>
          <p class="text-secondary small mb-0">A walking tour of Berlin that connects the dots — history, politics, and the stories behind the city you thought you knew.</p>
          <p class="text-secondary small mt-3">Berlin, Germany</p>
          <p class="text-secondary small mt-1">
            <a href="mailto:hello@connect-the-dots-tours.de" class="text-secondary">hello@connect-the-dots-tours.de</a>
          </p>
        </div>

        <div class="col-md-2 offset-md-2" data-n="footer-links">
          <h6 class="text-uppercase text-secondary fw-semibold small mb-3">Explore</h6>
          <ul class="list-unstyled mb-0 small">
            <li class="mb-2"><router-link to="/" class="text-white text-decoration-none">Home</router-link></li>
            <li class="mb-2"><router-link to="/tours" class="text-white text-decoration-none">Tours</router-link></li>
            <li class="mb-2"><router-link to="/about" class="text-white text-decoration-none">About us</router-link></li>
            <li class="mb-2"><router-link to="/is-it-for-you" class="text-white text-decoration-none">Is it for you?</router-link></li>
            <li><router-link to="/contact" class="text-white text-decoration-none">Contact</router-link></li>
          </ul>
        </div>

        <div class="col-md-3 offset-md-1" data-n="footer-cta">
          <h6 class="text-uppercase text-secondary fw-semibold small mb-3">Book a Tour</h6>
          <p class="text-secondary small mb-3">Not sure if this tour is for you? Take the quick quiz and find out.</p>
          <router-link to="/is-it-for-you" class="btn btn-outline-light btn-sm px-4">Is it for you?</router-link>
        </div>

      </div>
      <div class="pt-3 d-flex flex-column flex-sm-row justify-content-between align-items-center gap-2" data-n="footer-bottom">
        <p class="mb-0 text-secondary small">&copy; {{ year }} Berlin Connect-the-Dots Tours. All rights reserved.</p>
        <div class="d-flex gap-3">
          <router-link to="/privacy" class="text-secondary small text-decoration-none">Privacy Policy</router-link>
          <router-link to="/impressum" class="text-secondary small text-decoration-none">Impressum</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    year() { return new Date().getFullYear() }
  }
}
</script>
